<template>
    <children-route :animate="false" :animateKey="$route.params.contentmanager_id"></children-route>
</template>

<script>
  export default {
    name: 'index',
  }
</script>